import {
  mapCompanys,
  oilTypes,
  gasTypes,
  saleTypes,
  volumeType,
  depotTypes,
  depotCompanys
} from './map_lib'
import sysEnv from '@/env/envs'

let initMapChooseDepotType = function (data) {
  data = data || []
  let dataMap = {}
  depotTypes.forEach((item) => {
    dataMap[item.key] = true
  })
  return dataMap
}

let initMapChooseDepotCompany = function (data) {
  data = data || []
  let dataMap = {}
  depotCompanys.forEach((item) => {
    dataMap[item.key] = data.includes(item.key)
  })
  return dataMap
}

const state = {
  mapCompanys: mapCompanys,
  mapGass: [],
  mapOilTypes: oilTypes,
  mapGasTypes: gasTypes,
  mapSaleTypes: saleTypes,
  mapVolumeType: volumeType,
  mapChooseCmp: 'all',
  mapChooseGas: null,
  mapChooseOil: 'all',
  mapChooseGasType: null,
  mapChooseSaleType: ['dy10', 'qj5z10', 'qj3z5', 'xy3'],
  mapChooseVolumeType: 'sale',
  mapNeedMerge: true,
  mapHot: false,
  mapDepotTypes: depotTypes,
  mapDepotCompanys: depotCompanys,
  mapChooseDepotType: initMapChooseDepotType(),
  mapChooseDepotCompany: initMapChooseDepotCompany([sysEnv.zsyName]),
  // sczb 市场占比 xl 销量
  mapHotType: 'sczb',
  mapShowWarning: true,
  mapGdCmp: {
    [sysEnv.zsyName]: true,
    '中石化': true
  },
  mapShowBlockType: '',
  mapHotColorType: 1
}

const getters = {
  mapHotColorType: state => state.mapHotColorType,
  mapCompanys: state => state.mapCompanys,
  mapGdCmp: state => state.mapGdCmp,
  mapGass: state => state.mapGass,
  mapShowWarning: state => state.mapShowWarning,
  mapOilTypes: state => state.mapOilTypes,
  mapGasTypes: state => state.mapGasTypes,
  mapSaleTypes: state => state.mapSaleTypes,
  mapVolumeType: state => state.mapVolumeType,
  mapChooseCmp: state => state.mapChooseCmp,
  mapChooseGas: state => state.mapChooseGas,
  mapChooseOil: state => state.mapChooseOil,
  mapChooseGasType: state => state.mapChooseGasType,
  mapChooseSaleType: state => state.mapChooseSaleType,
  mapChooseVolumeType: state => state.mapChooseVolumeType,
  mapNeedMerge: state => state.mapNeedMerge,
  mapHot: state => state.mapHot,
  mapDepotTypes: state => state.mapDepotTypes,
  mapDepotCompanys: state => state.mapDepotCompanys,
  mapChooseDepotType: state => state.mapChooseDepotType,
  mapChooseDepotCompany: state => state.mapChooseDepotCompany,
  mapHotType: state => state.mapHotType,
  mapShowBlockType: state => state.mapShowBlockType
}

const actions = {
  mapSeriesDataClear ({ commit }) {
    commit('mapSeriesDataClear')
  },
  setMapGass ({ commit }, data) {
    commit('setMapGass', data)
  },
  setMapChooseCmp ({ commit, dispatch }, data) {
    commit('setMapChooseCmp', data)
    dispatch('mapUpdateMapData')
  },
  setMapChooseGas ({ commit, getters, dispatch }, data) {
    commit('setMapChooseGas', data)
    let point = null
    getters.mapSourceData.forEach((item) => {
      if (item.name === data) {
        point = item.point
      }
    })
    if (point) {
      dispatch('updateChartMap', {ponit: point, zoom: 13})
    }
  },
  setMapChooseOil ({ commit, dispatch }, data) {
    commit('setMapChooseOil', data)
    dispatch('mapUpdateMapData')
  },
  setMapChooseGasType ({ commit, dispatch }, data) {
    commit('setMapChooseGasType', data)
    dispatch('mapUpdateMapData')
  },
  setMapChooseSaleType ({ commit, dispatch }, data) {
    commit('setMapChooseSaleType', data)
    dispatch('mapUpdateMapData')
  },
  setMapChooseVolumeType ({ commit, dispatch }, data) {
    commit('setMapChooseVolumeType', data)
    dispatch('mapUpdateMapData')
  },
  setMapNeedMerge ({ commit, dispatch }, data) {
    commit('setMapNeedMerge', data)
    dispatch('mapUpdateMapData')
  },
  setMapHot ({ commit, dispatch }, data) {
    commit('setMapHot', data)
  },
  setMapShowBlockType ({ commit, dispatch }, data) {
    commit('setMapShowBlockType', data)
  },
  setMapHotType ({ commit, dispatch }, data) {
    commit('setMapHotType', data)
    dispatch('reMapXzqhHz')
  },
  setMapHotColorType ({ commit, dispatch }, data) {
    commit('setMapHotColorType', data)
    dispatch('reMapXzqhHz')
  },
  updateMapChooseDepotType ({ commit, dispatch }, data) {
    commit('updateMapChooseDepotType', data)
    dispatch('mapUpdateMapData')
  },
  updateMapGdCmp ({ commit, dispatch }, data) {
    commit('updateMapGdCmp', data)
    dispatch('mapUpdateMapData')
  },
  updateMapChooseDepotCompany ({ commit, dispatch }, data) {
    commit('updateMapChooseDepotCompany', data)
    dispatch('mapUpdateMapData')
  },
  setMapShowWarning ({ commit, dispatch }, data) {
    commit('setMapShowWarning', data)
    dispatch('mapUpdateMapData')
  }
}

const mutations = {
  mapSeriesDataClear (state) {
    state.mapCompanys = mapCompanys
    state.mapGass = []
    state.mapOilTypes = oilTypes
    state.mapGasTypes = gasTypes
    state.mapSaleTypes = saleTypes
    state.mapVolumeType = volumeType
    state.mapChooseCmp = 'all'
    state.mapChooseGas = null
    state.mapShowWarning = true
    state.mapChooseOil = 'all'
    state.mapChooseGasType = null
    state.mapChooseSaleType = ['dy10', 'qj5z10', 'qj3z5', 'xy3']
    state.mapChooseVolumeType = 'sale'
    state.mapNeedMerge = true
    state.mapDepotTypes = depotTypes
    state.mapDepotCompanys = depotCompanys
    state.mapChooseDepotType = initMapChooseDepotType()
    state.mapChooseDepotCompany = initMapChooseDepotCompany([sysEnv.zsyName])
    state.mapGdCmp = {
      [sysEnv.zsyName]: true,
      '中石化': true
    }
    state.mapShowBlockType = ''
    state.mapHotColorType = 1
  },
  setMapHotColorType (state, data) {
    state.mapHotColorType = data
  },
  setMapHotType (state, data) {
    state.mapHotType = data
  },
  setMapGass (state, data) {
    state.mapGass = data
  },
  setMapChooseCmp (state, data) {
    state.mapChooseCmp = data
  },
  setMapChooseGas (state, data) {
    state.mapChooseGas = data
  },
  setMapChooseOil (state, data) {
    state.mapChooseOil = data
  },
  setMapShowWarning (state, data) {
    state.mapShowWarning = data
  },
  setMapChooseGasType (state, data) {
    state.mapChooseGasType = data
  },
  setMapChooseSaleType (state, data) {
    state.mapChooseSaleType = data
  },
  setMapChooseVolumeType (state, data) {
    state.mapChooseVolumeType = data
  },
  setMapNeedMerge (state, data) {
    state.mapNeedMerge = data
  },
  setMapHot (state, data) {
    state.mapHot = data
  },
  setMapShowBlockType (state, data) {
    state.mapShowBlockType = data
  },
  updateMapGdCmp (state, {key, data}) {
    state.mapGdCmp[key] = data
  },
  updateMapChooseDepotType (state, {key, data}) {
    state.mapChooseDepotType[key] = data
  },
  updateMapChooseDepotCompany (state, {key, data}) {
    state.mapChooseDepotCompany[key] = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/map/search_block.js